export default "__VITE_ASSET__1H4z0yc$__"